import { render, staticRenderFns } from "./4_service_support.vue?vue&type=template&id=78579538&scoped=true&"
import script from "./4_service_support.vue?vue&type=script&lang=js&"
export * from "./4_service_support.vue?vue&type=script&lang=js&"
import style0 from "./4_service_support.vue?vue&type=style&index=0&id=78579538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78579538",
  null
  
)

export default component.exports